if (!customElements.get('wlsn-product-cards')) {
  class WLSNProductCards extends HTMLElement {
    constructor() {
      super();

      this.mobileMedia = window.matchMedia('(max-width: 1023px)');
      this.stickyTabs = null;
      this.originalTabs = null;
      this.productTabs = null;
      this.triggerScrollY = 0;
      this.mutationObserver = null;

      this._onMediaChange = this._onMediaChange.bind(this);
      this._onResize = this._onResize.bind(this);
      this._onScroll = this._onScroll.bind(this);
    }

    connectedCallback() {
      this.mobileMedia.addEventListener('change', this._onMediaChange);
      this._onMediaChange();
    }

    disconnectedCallback() {
      this.mobileMedia.removeEventListener('change', this._onMediaChange);
      this._destroyStickyTabs();
    }

    _onMediaChange() {
      if (this.mobileMedia.matches) {
        this._initializeStickyTabs();
      } else {
        this._destroyStickyTabs();
      }
    }

    _initializeStickyTabs() {
      const existingStickyTabs = document.querySelector('.wlsn-product-cards__sticky-tabs');
      const header = document.querySelector('wlsn-header');
      const headerWrapper = header?.querySelector(':scope > .wlsn-wrapper');

      this.productTabs = this.querySelector('wlsn-product-tabs');
      this.originalTabs = this.productTabs?.querySelector(':scope > wlsn-nav-tabs');

      if (this.stickyTabs || existingStickyTabs || !headerWrapper || !this.originalTabs) return;

      this.stickyTabs = this.originalTabs.cloneNode(true);
      this.stickyTabs.classList.add('wlsn-product-cards__sticky-tabs');
      this.stickyTabs.removeAttribute('center-tabs');
      const stickyTabsInner = this.stickyTabs.querySelector('.wlsn-nav-tabs__inner');
      stickyTabsInner?.classList.remove('is-centered');
      headerWrapper.insertAdjacentElement('afterend', this.stickyTabs);

      this._bindStickyTabs();
      this._setTriggerScrollY();

      window.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onResize, { passive: true });
      this._onScroll();
    }

    _bindStickyTabs() {
      const originalButtons = this._getTabButtons(this.originalTabs);
      const stickyButtons = this._getTabButtons(this.stickyTabs);

      stickyButtons.forEach((stickyButton, index) => {
        const originalButton = originalButtons[index];
        if (!originalButton) return;

        stickyButton.setAttribute('aria-label', originalButton.textContent.trim());
        stickyButton.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          originalButton.click();
          this._syncActiveTabs();
          this._scrollToProductTabs();
        });
      });

      this.mutationObserver = new MutationObserver(() => this._syncActiveTabs());
      originalButtons.forEach((button) => {
        this.mutationObserver.observe(button, {
          attributes: true,
          attributeFilter: ['class'],
        });
      });

      this._syncActiveTabs();
    }

    _getTabButtons(container) {
      return [...(container?.querySelectorAll('.js-product-tab-content-button') || [])];
    }

    _syncActiveTabs() {
      const originalButtons = this._getTabButtons(this.originalTabs);
      const stickyButtons = this._getTabButtons(this.stickyTabs);

      originalButtons.forEach((originalButton, index) => {
        const stickyButton = stickyButtons[index];
        if (!stickyButton) return;

        const isActive = originalButton.classList.contains('active');
        stickyButton.classList.toggle('active', isActive);
        stickyButton.setAttribute('aria-selected', isActive.toString());
      });
    }

    _getScrollOffset() {
      const header = document.querySelector('wlsn-header');
      const announcementBar = document.querySelector('wlsn-announcement-bar');
      return (header?.offsetHeight || 0) + (announcementBar?.offsetHeight || 0);
    }

    _setTriggerScrollY() {
      if (!this.originalTabs) return;
      const stickyTabsHeight = this.stickyTabs?.classList.contains('is-active')
        ? this.stickyTabs.offsetHeight
        : 0;
      this.triggerScrollY =
        this.originalTabs.getBoundingClientRect().top +
        window.scrollY -
        (this._getScrollOffset() - stickyTabsHeight);
    }

    _scrollToProductTabs() {
      if (!this.productTabs) return;
      const top =
        this.productTabs.getBoundingClientRect().top + window.scrollY - this._getScrollOffset();
      window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
    }

    _onResize() {
      if (!this.stickyTabs?.classList.contains('is-active')) {
        this._setTriggerScrollY();
      }
      this._onScroll();
    }

    _onScroll() {
      if (!this.stickyTabs || !this.originalTabs) return;

      const isActive = window.scrollY >= this.triggerScrollY;
      this.stickyTabs.classList.toggle('is-active', isActive);
      this.originalTabs.classList.toggle('wlsn-product-cards__original-tabs-hidden', isActive);

      if (isActive) this._syncActiveTabs();
    }

    _destroyStickyTabs() {
      window.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onResize);
      this.mutationObserver?.disconnect();
      this.originalTabs?.classList.remove('wlsn-product-cards__original-tabs-hidden');
      this.stickyTabs?.remove();

      this.mutationObserver = null;
      this.stickyTabs = null;
      this.originalTabs = null;
      this.productTabs = null;
    }
  }

  customElements.define('wlsn-product-cards', WLSNProductCards);
}
